import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import TooltipIcon from '../../../../components/tooltip-icon/TooltipIcon';
import { IProduct } from '../../../../shared/interfaces/IProduct';

type ProductNameProps = {
  product: IProduct;
};

const ProductName = ({ product }: ProductNameProps): JSX.Element | null => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const onProductNameClick = () => {
    const href = `/products/${product.id}/product-details`;

    navigate(href);
  };

  return (
    <div className='flex flex-row align-items-center gap-3'>
      <div
        onClick={onProductNameClick}
        className={'font-normal max-w-fit hover:underline cursor-pointer'}
      >
        {product.productName}
      </div>

      {product.sustainableAlternativeAvailable && (
        <TooltipIcon
          id={`products-table-sustainable-available-icon-tooltip-${product.id}`}
          tooltipText={t('global.sustainableAlternativeAvailable')}
          icon={
            <i
              className='cb cb-icon-leaf secondary-icon'
              style={{ width: '16px', height: '16px' }}
            />
          }
          position='right'
          width='fit'
        />
      )}
    </div>
  );
};

export default ProductName;
